/**
 *   Created by ATopcu in 2019
 */
import { selectScenarioEntityIds } from "state/scenario/selector";
import scope from "./scope";
import SelectionState from "state/selections/SelectionState";
import { selectDefinitions } from "./selectors";
import axios from "axios";
import {
  selectCommittedGroupTypeValue,
  selectCommittedGroupValues,
  selectAsOfDateValue,
  selectModeValue,
  selectSelectedEntityIds,
  selectBenchmarkEntityId,
} from "state/selections/selector";
import { throwError } from "@ls/error-module";
import { exchange } from "@ls/js-fetch";
import Mode from "state/selections/Mode";

export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});

export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});

export const REQUEST_TRADE_STRATEGY_GROUPS = `${scope}/REQUEST_TRADE_STRATEGY_GROUPS`;
export const RECEIVE_TRADE_STRATEGY_GROUPS = `${scope}/RECEIVE_TRADE_STRATEGY_GROUPS`;
export const requestTradeStrategyGroups = () => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_TRADE_STRATEGY_GROUPS });
    const { data } = await exchange({
      baseURL: process.env.REACT_APP_BASE_URL_TRADE_STRATEGY_MAPPING_SERVICE,
      url: "strategyGroupDecode",
    });
    dispatch({
      type: RECEIVE_TRADE_STRATEGY_GROUPS,
      data: data,
    });
  };
};

export const REQUEST_TRADE_STRATEGIES = `${scope}/REQUEST_TRADE_STRATEGIES`;
export const RECEIVE_TRADE_STRATEGIES = `${scope}/RECEIVE_TRADE_STRATEGIES`;
export const requestTradeStrategies = () => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_TRADE_STRATEGIES });
    const { data } = await exchange({
      baseURL: process.env.REACT_APP_BASE_URL_TRADE_STRATEGY_MAPPING_SERVICE,
      url: "tradeStrategy",
    });
    dispatch({
      type: RECEIVE_TRADE_STRATEGIES,
      data: data,
    });
  };
};

export const REQUEST_DATA = `${scope}/REQUEST_DATA`;
export const RECEIVE_DATA = `${scope}/RECEIVE_DATA`;
export const requestTradeTrackingErrorData = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const tradeTrackingErrorDefinitions = selectDefinitions(
      SelectionState.COMMITTED
    )(state);
    const baseParams = {
      date: selectAsOfDateValue(SelectionState.COMMITTED)(state),
    };

    const modeValue = selectModeValue(SelectionState.COMMITTED)(state);
    const selectedBenchmarkEntityId = selectBenchmarkEntityId(
      SelectionState.UNCOMMITTED
    )(state);
    if (modeValue === Mode.ACC_GROUPS) {
      baseParams.groupType = selectCommittedGroupTypeValue(state);
      baseParams.groupIds = selectCommittedGroupValues(state)?.join(",");
    } else if (modeValue === Mode.ENTITIES) {
      baseParams.groupType = "entity_list";
      baseParams.groupIds = selectSelectedEntityIds(SelectionState.COMMITTED)(
        state
      )?.join(",");
    } else if (modeValue === Mode.SCENARIOS) {
      baseParams.groupType = "entity_list";
      baseParams.groupIds = selectScenarioEntityIds(state)?.join(",");
    }
    tradeTrackingErrorDefinitions.forEach((definition) => {
      if (definition.summary === "ABSOLUTE" && !selectedBenchmarkEntityId) {
        baseParams.benchmarkId = 0;
      } else if (!!selectedBenchmarkEntityId) {
        baseParams.benchmarkId = selectedBenchmarkEntityId;
      } else {
        delete baseParams.benchmarkId;
      }
      dispatch({ type: REQUEST_DATA, payload: { key: definition.key } });
      axios({
        baseURL: process.env.REACT_APP_BASE_URL_TRACKING_ERROR_SERVICE,
        url: "trades",
        params: {
          ...baseParams,
          tradeTrackingErrorType: definition.tradeTrackingErrorType,
          covarMatrixType: definition.covarianceType,
          strategyGroupId: definition.strategyGroupId,
          tradeStrategyIds: definition.tradeStrategyId,
        },
      })
        .then((resp) => {
          dispatch({
            type: RECEIVE_DATA,
            summary: definition.summary,
            payload: {
              key: definition.key,
              data: resp.data,
            },
          });
        })
        .catch((err) => {
          dispatch({
            type: RECEIVE_DATA,
            payload: {
              key: definition.key,
              data: null,
            },
          });
          throwError({ ...err, title: "Trade Tracking Service Error" });
        });
    });
  };
};
